import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as AngleUpIcon } from "../../assets/angle-up.svg";
import Lock from "../../assets/lock.svg";
import { ReactComponent as MinusIcon } from "../../assets/minus.svg";
import BorderlessButton from "../../lib/borderless-button/borderless-button";
import {
  dateToString,
  getBeginningOfDate,
  getEndOfDate,
  getIconColor,
  getIconColorAging,
} from "../../lib/Helper";
import Switch from "../../lib/switch/switch";

const MarkerFilters = ({
  types,
  filters,
  onChange,
  showRemoved,
  onShowRemoved,
  dateRange,
  onDateRangeChange,
  dataBounds,
}) => {
  const [isCollapsed, setCollapsed] = useState(false);
  let newFilters = { ...filters };

  const setFilters = (id, filter, aging) => {
    let _id = id;
    if (aging) _id = "aging_" + id;
    if (newFilters[_id] && !filter) {
      delete newFilters[_id];
    } else {
      newFilters[_id] = true;
    }
    onChange(newFilters);
  };

  const collapsePressed = () => {
    setCollapsed(!isCollapsed);
  };
  var drawLine = true;
  return (
    <div className="map-inner-view map-filters">
      <div className="top-view">
        <BorderlessButton
          className="collapse-btn"
          icon={
            isCollapsed ? (
              <AngleUpIcon className="icon-small" />
            ) : (
              <MinusIcon className="icon-small" />
            )
          }
          onClick={collapsePressed}
          tier={1}
          shadowType={BorderlessButton.ShadowType.NONE}
        />
      </div>
      <div
        id="filters-content-view"
        className={`content-view ${isCollapsed ? "content-view--collapsed" : ""}`}
      >
        {types &&
          Object.values(types).map((type) => {
            const selected = filters[type.id] ? false : true;
            return (
              <div key={type.id} className="marker-row">
                <div
                  className="marker"
                  style={{ backgroundColor: getIconColor(type.iconId) }}
                />
                <p>{type.iconId === 0 ? "Huomio" : type.name}</p>
                <div style={{ flexGrow: 1 }} />
                {type.isLocked && (
                  <img
                    src={Lock}
                    style={{ width: "15px", marginRight: "6px" }}
                  />
                )}
                <Switch
                  selected={selected}
                  onChange={(selected) => setFilters(type.id, !selected, false)}
                />
              </div>
            );
          })}
        {types &&
          Object.values(types).map((type) => {
            if (!type.aging) return null;
            const _drawLine = drawLine;
            drawLine = false;
            const selected = filters[`aging_${type.id}`] ? false : true;
            return (
              <div key={type.id}>
                {_drawLine && (
                  <div
                    style={{
                      borderTop: "solid 1px #e1e1e1",
                      height: "6px",
                      background: "none",
                    }}
                  />
                )}
                <div key={type.id} className="marker-row">
                  <div
                    className="marker"
                    style={{ backgroundColor: getIconColorAging(type.iconId) }}
                  />
                  <div>
                    <p style={{ marginBottom: 0 }}>{type.name}</p>
                    <p
                      style={{
                        fontSize: "0.8rem",
                        fontColor: "#989898",
                        marginBottom: 0,
                        marginTop: "-4px",
                      }}
                    >
                      (vanhentunut)
                    </p>
                  </div>
                  <div style={{ flexGrow: 1 }} />
                  <Switch
                    selected={selected}
                    onChange={(selected) =>
                      setFilters(type.id, !selected, true)
                    }
                  />
                </div>
              </div>
            );
          })}
      </div>
      <div className="map-filters-fixed">
        <div
          style={{
            borderTop: "solid 1px #e1e1e1",
            height: "6px",
            background: "none",
          }}
        />
        <div className="marker-row">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
              marginBottom: 4,
            }}
          >
            <p style={{ margin: 0 }}>Hae poistetut</p>
            <div style={{ flexGrow: 1 }} />
            {showRemoved && showRemoved.from && showRemoved.to && (
              <p style={{ margin: 0, fontWeight: 300 }}>
                {dateToString(new Date(showRemoved.from), false)} -{" "}
                {dateToString(new Date(showRemoved.to), false)}
              </p>
            )}
          </div>
          <Switch
            selected={showRemoved ? true : false}
            onChange={(on) => onShowRemoved(on)}
          />
        </div>
        <div
          style={{
            borderTop: "solid 1px #e1e1e1",
            height: "6px",
            background: "none",
          }}
        />
        <div className="marker-row">
          <div
            style={{
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
            <p style={{ margin: 0 }}>Pisteiden aikaväli</p>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 8,
                alignItems: "flex-start",
              }}
            >
              <div>
                <p style={{ margin: 0, fontSize: "0.85rem", fontWeight: 300 }}>
                  Alkaen
                </p>
                <DatePicker
                  selected={
                    dateRange && dateRange.from != null
                      ? new Date(dateRange.from)
                      : null
                  }
                  onChange={(date) => {
                    const from = date
                      ? getBeginningOfDate(new Date(date), true)
                      : null;
                    const to =
                      dateRange && dateRange.to != null ? dateRange.to : null;
                    // Validate: from should not exceed to
                    if (from != null && to != null && from > to) return;
                    onDateRangeChange(
                      from != null || to != null
                        ? { from: from ?? undefined, to: to ?? undefined }
                        : undefined,
                    );
                  }}
                  dateFormat="d.M.yyyy"
                  placeholderText="–"
                  isClearable
                  minDate={
                    dataBounds && dataBounds.from != null
                      ? new Date(dataBounds.from)
                      : undefined
                  }
                  maxDate={
                    dateRange && dateRange.to != null
                      ? new Date(dateRange.to)
                      : dataBounds && dataBounds.to != null
                        ? new Date(dataBounds.to)
                        : undefined
                  }
                />
              </div>
              <div>
                <p style={{ margin: 0, fontSize: "0.85rem", fontWeight: 300 }}>
                  Päättyen
                </p>
                <DatePicker
                  selected={
                    dateRange && dateRange.to != null
                      ? new Date(dateRange.to)
                      : null
                  }
                  onChange={(date) => {
                    const to = date ? getEndOfDate(new Date(date), true) : null;
                    const from =
                      dateRange && dateRange.from != null
                        ? dateRange.from
                        : null;
                    // Validate: to should not be before from
                    if (from != null && to != null && to < from) return;
                    onDateRangeChange(
                      from != null || to != null
                        ? { from: from ?? undefined, to: to ?? undefined }
                        : undefined,
                    );
                  }}
                  dateFormat="d.M.yyyy"
                  placeholderText="–"
                  isClearable
                  minDate={
                    dateRange && dateRange.from != null
                      ? new Date(dateRange.from)
                      : dataBounds && dataBounds.from != null
                        ? new Date(dataBounds.from)
                        : undefined
                  }
                  maxDate={
                    dataBounds && dataBounds.to != null
                      ? new Date(dataBounds.to)
                      : undefined
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarkerFilters;
